import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import TemplateFields, { useTemplateForm, firstName } from "@/components/conversations/TemplateFields";
import { CONVERSATIONS } from "@/constants/testIds";

// Fix O (2026-09-30): mandar una plantilla en una conversacion (pasadas las 24 h)
// o empezar una conversacion nueva con un numero (askPhone).
export default function TemplateDialog({ open, onOpenChange, title, askPhone = false, patientName = "", language = "es", preferred, onSend }) {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [sending, setSending] = useState(false);
  const who = firstName(askPhone ? name : patientName);
  const form = useTemplateForm(open, preferred, { nombre: who, 1: who }, language);

  useEffect(() => {
    if (open) {
      setPhone("");
      setName("");
    }
  }, [open]);

  const canSend = form.complete && (!askPhone || phone.trim()) && !sending;

  const handleSend = async () => {
    setSending(true);
    try {
      const ok = await onSend({ phone: phone.trim(), name: name.trim(), template: form.template.name, language: form.template.language, params: form.values });
      if (ok) onOpenChange(false);
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={CONVERSATIONS.templateDialog}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          {askPhone && (
            <>
              <div>
                <Label className="text-sm text-muted-foreground mb-1 block">Numero de WhatsApp (con codigo de pais)</Label>
                <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+1 713 555 1234" data-testid={CONVERSATIONS.templatePhoneInput} />
              </div>
              <div>
                <Label className="text-sm text-muted-foreground mb-1 block">Nombre (opcional)</Label>
                <Input value={name} onChange={(e) => setName(e.target.value)} data-testid={CONVERSATIONS.templateNameInput} />
              </div>
            </>
          )}
          <TemplateFields form={form} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={handleSend} disabled={!canSend} className="bg-brand hover:bg-brand-hover text-white" data-testid={CONVERSATIONS.templateSendButton}>
            {sending ? "Enviando..." : "Enviar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
